import React from 'react';

// Check glyphs matching the handoff's stroked SVG icons (Icons.jsx is a dormant
// global-bundle script without exports, so the paths are inlined here).
function CheckIcon() {
  return (
    <svg
      width={13}
      height={13}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={2.2}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M5 12l4.5 4.5L19 7' />
    </svg>
  );
}

function DoubleCheckIcon() {
  return (
    <svg
      width={15}
      height={15}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.8}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M2 13l4 4 8-9' />
      <path d='M11 16l1 1 8-9' />
    </svg>
  );
}

// Bravo multi-select chip grid (handoff: mass-status-by-period, period-grid section).
// items: [{ key, label, checked }] — onChange receives the full updated array.
// label is the optional uppercase section label; omit it when the host (e.g. a
// wizard field row) already renders one.
function ToggleChipGrid({ label = null, items, onChange }) {
  const chips = items ?? [];
  const checkedCount = chips.filter((item) => item.checked).length;
  const allOn = chips.length > 0 && checkedCount === chips.length;

  const toggleAll = () => onChange(chips.map((item) => ({ ...item, checked: !allOn })));
  const toggleOne = (key, checked) => onChange(chips.map((item) => (item.key === key ? { ...item, checked } : item)));

  return (
    <div className='bravo-ds'>
      <div className='period-head'>
        {label && <div className='us-section-lbl'>{label}</div>}
        <span className='period-count'>
          {checkedCount} of {chips.length} selected
        </span>
        <div className='sp' />
        <button
          type='button'
          className='link-btn'
          onClick={toggleAll}
        >
          <DoubleCheckIcon /> {allOn ? 'Deselect all' : 'Select all'}
        </button>
      </div>
      <div className='period-grid'>
        {chips.map((item) => (
          <label
            className={item.checked ? 'period-chip on' : 'period-chip'}
            key={item.key}
          >
            <input
              type='checkbox'
              checked={item.checked}
              onChange={(e) => toggleOne(item.key, e.target.checked)}
            />
            <span className='pc-box'>{item.checked && <CheckIcon />}</span>
            {item.label}
          </label>
        ))}
      </div>
    </div>
  );
}

export default ToggleChipGrid;
